import * as actionTypes from "../actionTypes/Index";
import { newsfeedInitialState } from "./InitialState";
import {
  IActionType,
  IFetchNewsfeedActionResponse,
} from "../../interfaces/Index";

const initialState = { ...newsfeedInitialState };

export const appendUpdateNewsfeed = (
  payload: IFetchNewsfeedActionResponse,
  state: any
) => {
  if (payload.isPaginatedRes) {
    return [...state.newsfeedListFetched, ...payload.newsfeedListsData];
  }
  return payload.newsfeedListsData.slice();
};

export default function newsfeedReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.GET_NEWSFEED_LIST_INIT: {
      return Object.assign({}, state, {
        isFetchNewsfeedLoading: true,
        isFetchNewsfeedError: false,
        isNewsfeedAdded: false,
        isNewsfeedUpdated: false,
        error: null,
        isError: false,
      });
    }
    case actionTypes.GET_NEWSFEED_LIST_SUCCESS: {
      return Object.assign({}, state, {
        isFetchNewsfeedLoading: false,
        newsfeedListFetched: appendUpdateNewsfeed(action.payload as any, state),
        pagination: (action.payload! as any).pagination,
      });
    }
    case actionTypes.GET_NEWSFEED_LIST_FAIL: {
      return Object.assign({}, state, {
        isFetchNewsfeedLoading: false,
        isFetchNewsfeedError: true,
        error: action.error,
      });
    }
    case actionTypes.CREATE_NEWSFEED_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isNewsfeedAdded: false,
        error: null,
      });
    }
    case actionTypes.CREATE_NEWSFEED_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isNewsfeedAdded: true,
      });
    }
    case actionTypes.CREATE_NEWSFEED_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isNewsfeedAdded: false,
        error: action.error,
      });
    }
    case actionTypes.UPDATE_NEWSFEED_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isNewsfeedUpdated: false,
        error: null,
        isNewsfeedAdded: false,
      });
    }
    case actionTypes.UPDATE_NEWSFEED_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isNewsfeedUpdated: true,
      });
    }
    case actionTypes.UPDATE_NEWSFEED_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isNewsfeedUpdated: false,
        error: action.error,
      });
    }
    default:
      return state;
  }
}